
import loader from '@/assets/images/loader2.svg'

export default {
    components: { loader },
}
